import React, { useEffect, useMemo, useState } from "react";
import Heading from "../../components/Heading";
import CommonGrid from "../../components/CommonGrid";
import { Button } from "../../components/Button";
import { ArrowLeft } from "react-bootstrap-icons";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import {
  vomColumnsDefs,
  vomColumnsDefsForBorrower,
} from "../../Utils/TableColumnDefs";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { VOMNavbar } from ".";
import {
  isValidEmail,
  LiButton,
  LiHandleButton,
} from "../../Utils/CustomComponent";
import {
  fetchVOMRequests,
  fetchVOMRequestsForBorrower,
} from "../../store/reducers/dashboardSlice/api";

const BorrowerVOMTable = () => {
  const [activeTab, setActiveTab] = useState(0);
  const data = useSelector((state) => state.dashboard.borrowerVOMRequests.data);
  const status = useSelector(
    (state) => state.dashboard.borrowerVOMRequests.status,
  );
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  const isAuthenticated = useSelector(
    (state) => state.RS_Authentication.isAuthenticated,
  );
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );

  const accounts = useMemo(
    () => accountOptions.map((item) => item.value),
    [accountOptions],
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pendingRequests =
    data?.filter((item) => item?.status === "PENDING") ?? [];
  const submittedRequests =
    data?.filter((item) => item?.status === "SUBMITTED") ?? [];
  const closedRequests =
    data?.filter((item) => item?.status === "CLOSED") ?? [];

  useEffect(() => {
    if (accounts?.length) {
      dispatch(
        fetchVOMRequestsForBorrower({
          payload: { loanrecid: accounts },
        }),
      );
    }
  }, [dispatch, accounts]);

  const componentConfig = [
    {
      component: (
        <Heading className="col-sm-12" text="Verification of Mortgage" />
      ),
      role: ["Both"],
      className: "col-sm-6 px-5",
    },
    {
      component: (
        <Button
          className={`${isAuthenticated && selectedRole === "B" ? "d-none" : ""}`}
          onClick={() => navigate(`/verification-form/${email}`)}
          text="+ Request Verification of Mortgage"
        />
      ),
      role: ["Both"],
      className: "col-sm-6 px-5 text-end",
    },
    {
      component: (
        <div>
          <ul className="nav nav-tabs mt-5 px-5">
            {tabButtons.map((data, index) => (
              <LiButton
                key={index}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                label={data.label}
                value={index}
              />
            ))}
          </ul>

          <section className="row d-flex flex-row align-items-stretch justify-content-stretch px-5">
            {activeTab === 0 && (
              <CommonGrid
                className={"bg-white col-sm-12 mt-5"}
                title={"Pending VOM Requests"}
                gridColumns={vomColumnsDefsForBorrower(navigate)}
                columnData={pendingRequests}
                status={status}
              />
            )}
            {activeTab === 1 && (
              <CommonGrid
                className={"bg-white col-sm-12 mt-5"}
                title={"Completed VOM Requests"}
                gridColumns={vomColumnsDefsForBorrower(navigate)}
                columnData={submittedRequests}
                status={status}
              />
            )}
            {activeTab === 2 && (
              <CommonGrid
                className={"bg-white col-sm-12 mt-5"}
                title={"Closed VOM Requests"}
                gridColumns={vomColumnsDefsForBorrower(navigate)}
                columnData={closedRequests}
                status={status}
              />
            )}
          </section>
        </div>
      ),
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{
          background: "#eeeeee",
          minHeight: "100vh",
        }}
      >
        <nav aria-label="breadcrumb" className="mb-4 mx-5 px-4">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <span
                className="linkClick"
                role="button"
                onClick={() => navigate(-1)}
              >
                Back
              </span>
            </li>
            <li className="breadcrumb-item active">VOM Requests</li>
          </ol>
        </nav>

        <article className="container-fluid row">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};

export default BorrowerVOMTable;

const tabButtons = [
  {
    label: "Pending Requests",
    title: "Pending Requests",
  },
  { label: "Submitted Requests", title: "Submitted Requests" },
  { label: "Closed Requests", title: "Closed Requests" },
];
